enum LOCATION_MODAL_BASIC_INFO {
  loginWithYourPickupAccount = 'loginWithYourPickupAccount',
}

export { LOCATION_MODAL_BASIC_INFO };
